import React from 'react';

import { ReactComponent as LocationSvg } from '../../assests/images/jobs/location-pin-hole.svg';

export default function LocationPinHoleIcon(props) {

    return (
        <LocationSvg className="Location-pin-hole-icon icon" />
    );
}